
define('template!webshopCategoriesDetailBodyUrlsBodyDomainErrorModalView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="body">\n  <div class="message-container">\n    <div class="icon">\n      <svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 512 512"><!--!Font Awesome Free 6.5.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2023 Fonticons, Inc.--><path fill="red" d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24V264c0 13.3-10.7 24-24 24s-24-10.7-24-24V152c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg>\n    </div>\n    <div class="text">' +
((__t = ( errorMessage )) == null ? '' : __t) +
'</div>\n  </div>\n  ';
 if (hasParentId) { ;
__p += '\n  <div class="category-button-region"></div>\n  ';
 } ;
__p += '\n</div>\n';

}
return __p
};});

